import React, { useCallback, useEffect, useState } from "react";
import s from './TutorGroupComponent.module.css';
import { useNavigate } from "react-router-dom";
import {getData, postData} from '../middleware/apiMiddleware';
import {modifiedDateWithYear, modifiedDate, getTodayFull} from '../middleware/dateControl';
import SmallCalendar from '../components/SmallCalendar';
import moment from 'moment';
import renewableEnergy from'../asset/renewable-energy.png';
import SmallTutorGroupDayLesson from './SmallTutorGroupDayLesson';
import {RedButton} from './MyButton';

export default function TutorGroupComponent({tutorGroupId, setTutorGroupId}) {	
	const navigate = useNavigate();
		
	const [tutorGroup, setTutorGroup] = useState();
	
	const [extraDayData, setExtraDay] = useState([]);
	
	const fetchData = () => {
		getData('tutorApi/getTutorGroupById?tutorGroupId=' + tutorGroupId, navigate)
		.then(res => {
				let data = res.data;
				
				data.zooms = data.zooms.sort(function(a,b){
					return new Date(a.zStartDate) - new Date(b.zStartDate);
				});
				
				let usedDayIds = [];
				if (data.zooms) {
					data.zooms.forEach((z)=>{
						z.dayObj = data.json.plan.filter(o => o.day_id == z.dayId);
						
						if ((z.dayId) && !usedDayIds.includes(z.dayId)) {
							usedDayIds.push(parseInt(z.dayId));
						}
					})
				}
				
				let zData = [];
				data.json.plan.forEach((d)=>{
					if (!usedDayIds.includes(parseInt(d.day_id))) {
						
						zData.push(d);
					}
				})
				
				setTutorGroup(data);
				setExtraDay(zData);
			}
		);
		
	}
	
	useEffect(() => {
		if (tutorGroupId) {
			//setTargetZoomIndex(false);
			//setTargetSwapDayTaskObj(false);
			fetchData();
		}
	}, [tutorGroupId]);
	
	const [targetZoomIndex, setTargetZoomIndex] = useState(false);
	const [targetSwapDayTaskObj, setTargetSwapDayTaskObj] = useState(false);
	
	/*const dragOver = (e) => {
		e.preventDefault();
	}
	const [dragDay, setDragDay] = useState();
	const onDragStart = (e, d) => {
		console.log(d);
		setDragDay(d);
	}*/
	
	const dropOffDayTask = (indexZ) => {
		setTargetSwapDayTaskObj(false);
				
		let tmpZoomTask = [...tutorGroup.zooms];
		
		if (tmpZoomTask[indexZ].dayObj.length == 0) {
			return;
		}
		
		let dropTask = tmpZoomTask[indexZ].dayObj.pop();
		
		setTutorGroup({...tutorGroup, "zooms":tmpZoomTask});
		
		let tmpExtraDay = [...extraDayData];
		tmpExtraDay.push(dropTask);
		setExtraDay(tmpExtraDay);
		
	}
	
	const prepareSwapTask = (day) => {
		if (targetZoomIndex === false) {
			return;
		}
		setTargetSwapDayTaskObj(day);
	}
	
	const swapTask = () => {
		if (targetZoomIndex === false || targetSwapDayTaskObj === false) {
			return;
		}
		
		
		let tmpExtraDay = [...extraDayData.filter(o => o.day_id != targetSwapDayTaskObj.day_id)];
		
		let swapDay = null;
		
		swapDay = {...targetSwapDayTaskObj};
		
		if (swapDay) {
			tmpExtraDay.push(swapDay);
		}
		setExtraDay(tmpExtraDay);
		let tmpZooms = [...tutorGroup.zooms];
		tmpZooms[targetZoomIndex].dayObj = [targetSwapDayTaskObj];
		
		setTutorGroup({...tutorGroup, ['zooms']:tmpZooms});
		
		setTargetSwapDayTaskObj(false);
		setTargetZoomIndex(false);
		
	}
	
	const Zooms = ({z, indexZ, onClickAction, onDoubleClickAction}) => {
		return (
			<div key={z.zoomId} className={[s.zoomCardContainer, (targetZoomIndex === indexZ) ? s.activeContainer : ""].join(' ')} onClick={onClickAction} onDoubleClick={onDoubleClickAction}>
				
				<div className={[s.cancelOverlay, (z.isCancel) ? s.cancelOverlayActive : ""].join(' ')}>
					<div className={s.cancelOverlayFont}>Cancel</div>
				</div>
				
				<div className={s.zoomCardHolder}>
					{(z.zStartDate > getTodayFull()) && <div></div>}
					<div>
						<div className={s.zoomCard}>
							<div>
								<div><span className={s.spanBold}>ZoomID - {z.zoomId}</span></div>
								<div className={s.spanLight}>{z.zTitle}</div>
								<div>{modifiedDate(z.zStartDate)}</div>
							</div>
							<div><SmallCalendar date={z.zStartDate}/></div>
						</div>
					</div>
					
					<div className={s.dayObj}>
						{(z.dayObj) && (<div>{z.dayObj.map((d)=>{
							return (<div key={z.zoomId+ '-' +d.day_id}>{(d.day_id) && <SmallTutorGroupDayLesson day = {d}/>}</div>)
						})}</div>)}
					
					</div>
				</div>
			</div>
		);
	}
	
	return (<div className={s.container}>
			<div className={[s.modalUpdatedContentWrapper, (tutorGroupId ? s.ucShow: s.ucHide)].join(' ')}>
				<div className={[s.modalUpdateGuideline, (targetZoomIndex === false ? s.gShow: s.gHide)].join(' ')}>
					<p>Click left panel to mark the edit zoom</p>
					<p>Click right panel to swap task from marked zoom</p>
					<p>Double click left panel to remove work task</p>
				</div>
				<div className={[s.modalUpdatePanel, (targetZoomIndex !== false ? s.gShow: s.gHide)].join(' ')}>
					<div className={s.modalZoomHolder}>
						{(targetZoomIndex !== false) && (<div>
								<Zooms z={tutorGroup.zooms[targetZoomIndex]} />
							</div>
						)}
					</div>
					<div className={[s.swapButtonHolder].join(' ')}>{
						(targetZoomIndex !== false && targetSwapDayTaskObj !== false) && (
							<div><RedButton className={[s.swapButton].join(' ')} isEnabled={true} clickedAction={()=>{swapTask()}} bText={(tutorGroup.zooms[targetZoomIndex].dayObj.length==0) ? "Add" : "Swap" + "?"} /></div>)
						}
					</div>
					<div className={[s.modalDayHolder, (targetZoomIndex !== false && targetSwapDayTaskObj !== false) ? s.gShow: s.gHide ].join(' ')}>
						{(targetZoomIndex !== false && targetSwapDayTaskObj !== false) && (<div className={s.dayContainer}>
								<SmallTutorGroupDayLesson day = {targetSwapDayTaskObj}/>
							</div>
						)}
					</div>
				</div>
			</div>
	
	
			<div className={[s.modalContentWrapper, (tutorGroupId ? s.cShow: s.cHide)].join(' ')}>	
				<div className={s.ndContainer}>
					<div className={s.zoomHolder}>
						{
							(tutorGroup) && (
								tutorGroup.zooms.map((z, indexZ) => (<Zooms z={z} indexZ={indexZ} onClickAction={()=>setTargetZoomIndex(indexZ)} onDoubleClickAction={()=>dropOffDayTask(indexZ)} />))
							)
						}
					</div>
					
					<div className={s.dayHolder}>
						{
							extraDayData.map((d)=> {
								return (<div key={"emp - " + d.day_id} className={[s.zoomCardContainer, (targetSwapDayTaskObj.day_id == d.day_id) ? s.activeDay : ""].join(' ')} onClick={()=>prepareSwapTask(d)}>
									<SmallTutorGroupDayLesson day = {d}/>
								</div>);
							})
						}
					</div>
				
				</div>
			</div>
			
			<div className={[s.modalBackdrop, (tutorGroupId ? s.modal : s.modalHide)].join(' ')} onClick={()=>{ setTutorGroupId(null)}}/>
			
		</div>);
}